/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import GaugeComponent from 'react-gauge-component';
import './styles.css';

type Props = {
  value: number; // Gauge değeri 1-10 arası
};

const Gauge: React.FC<Props> = ({ value }) => {
  // Ölçekli alt aralıkları tanımla
  const subArcs = [
    { limit: 4, color: '#D9214E' }, // 1-3 arası kırmızı
    { limit: 7, color: '#F1BC00' }, // 4-6 arası sarı
    { limit: 10, color: '#47BE7D' }, // 7-10 arası yeşil
  ];

  return (
    <GaugeComponent
      value={value} // 1-10 arası değeri %0-%100 aralığına dönüştür
      type="semicircle"
      minValue={1} // Minimum değer
      maxValue={10} // Maksimum değer
      style={{ width: 300 }}
      labels={{
        valueLabel: {
          style: { display: 'none' },
          formatTextValue: (value: number) => `${Math.round(value / 10) + 1}`, // Orijinal değeri geri almak için
        },
        tickLabels: {
          type: "inner",
          ticks: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }, { value: 6 }, { value: 7 }, { value: 8 }, { value: 9 }, { value: 10 }],
        },
      }}
      arc={{
        colorArray: ['#EA4228', '#F5CD19', '#5BE12C'],
        subArcs: subArcs,
        padding: 0.015,
        width: 0.2,
        cornerRadius: 1,

      }}
      pointer={{
        elastic: true,
        animationDelay: 500,
        width: 15,
      }}
    />
  );
};

export { Gauge };
